module.exports = __webpack_public_path__ + "img/personb.41b58619.png";